module.exports = __webpack_public_path__ + "static/media/left.47d956df.png";